import {
  FETCH_REQUEST_FAILURE,
  FETCH_REQUEST_LOADING,
  FETCH_REQUEST_SUCCESS,
  DELETE_REQUEST_LOADING,
  DELETE_REQUEST_SUCCESS,
  DELETE_REQUEST_FAILURE
} from '../Types/requestTypes';

const initState = {
  data: [],
  pagination: null,
  error: null,
  loading: true
};

const requestReducer = (state = initState, action) => {
  switch (action.type) {
    case FETCH_REQUEST_LOADING:
      return {
        ...state,
        loading: true
      };
    case FETCH_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.data,
        pagination: action.payload.pagination
      };
    case FETCH_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case DELETE_REQUEST_LOADING:
      return {
        ...state,
        loading: true
      };
    case DELETE_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: state.data.filter(request => request._id._id !== action.payload)
      };
    case DELETE_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return { ...state };
  }
};

export default requestReducer;
